/*** IMPORTS FROM imports-loader ***/


/**
 * GIS Server APIs
 * A powerful suite of mapping, geospatial and location-based APIs for your applications and services.
 *
 * OpenAPI spec version: v1.0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 2.3.1
 *
 * Do not edit the class manually.
 *
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'));
  } else {
    // Browser globals (root is window)
    if (!root.GisServerApis) {
      root.GisServerApis = {};
    }
    root.GisServerApis.PersistedGrantResource = factory(root.GisServerApis.ApiClient);
  }
}(this, function(ApiClient) {
  'use strict';




  /**
   * The PersistedGrantResource model module.
   * @module model/PersistedGrantResource
   * @version 1.0.0
   */

  /**
   * Constructs a new <code>PersistedGrantResource</code>.
   * A class that includes the persisted grant information.
   * @alias module:model/PersistedGrantResource
   * @class
   */
  var exports = function() {
    var _this = this;






  };

  /**
   * Constructs a <code>PersistedGrantResource</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/PersistedGrantResource} obj Optional instance to populate.
   * @return {module:model/PersistedGrantResource} The populated <code>PersistedGrantResource</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (data.hasOwnProperty('key')) {
        obj['key'] = ApiClient.convertToType(data['key'], 'String');
      }
      if (data.hasOwnProperty('accountId')) {
        obj['accountId'] = ApiClient.convertToType(data['accountId'], 'String');
      }
      if (data.hasOwnProperty('creationTime')) {
        obj['creationTime'] = ApiClient.convertToType(data['creationTime'], 'Date');
      }
      if (data.hasOwnProperty('expiration')) {
        obj['expiration'] = ApiClient.convertToType(data['expiration'], 'Date');
      }
      if (data.hasOwnProperty('lastUsedTime')) {
        obj['lastUsedTime'] = ApiClient.convertToType(data['lastUsedTime'], 'Date');
      }
    }
    return obj;
  }

  /**
   * The unique key of the persisted grant.
   * @member {String} key
   */
  exports.prototype['key'] = undefined;
  /**
   * The ID of owner.
   * @member {String} accountId
   */
  exports.prototype['accountId'] = undefined;
  /**
   * The creation time of the persisted grant.
   * @member {Date} creationTime
   */
  exports.prototype['creationTime'] = undefined;
  /**
   * The expiration of the persisted grant.
   * @member {Date} expiration
   */
  exports.prototype['expiration'] = undefined;
  /**
   * The last used time of the peristed garnt.
   * @member {Date} lastUsedTime
   */
  exports.prototype['lastUsedTime'] = undefined;



  return exports;
}));



